import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import { Body, DivDigital, BotaoLeft } from './style'
import SetaEsquerda from '../img/Seta_Esquerda.png';
import { SiteTopo } from "../topo";
import { TopoSeta } from "./videos/style";

export const CalcDigital = () => {

    const [focused, setFocused] = useState(false)


    const [radio, setRadio] = useState('1')
    const [etqquantidade, setEtqquantidade] = useState('1000')
    const [etqlargura, setEtqlargura] = useState('100') // Não esta funcionando
    const [etqaltura, setEtqaltura] = useState('100')
    const [total, setTotal] = useState('')
    const [retornoTotal, setRetornoTotal] = useState('')

    var MateriaPrima = '';
    const Couche = 3;
    const Bopp_20gr = 5;
    const Bopp_30gr = 5.5;
    const Bopp_B_30gr = 10;
    const Bopp_Prata = 12;
    const Bopp_Transp = 7;
    const Vinil = 15;
    const Couche_Esp_Vergara = 15;

    (radio === '1') ? MateriaPrima = Couche :
        (radio === '2') ? MateriaPrima = Bopp_20gr :
            (radio === '3') ? MateriaPrima = Bopp_30gr :
                (radio === '4') ? MateriaPrima = Bopp_B_30gr :
                    (radio === '5') ? MateriaPrima = Couche_Esp_Vergara :
                        (radio === '6') ? MateriaPrima = Bopp_Transp :
                            (radio === '7') ? MateriaPrima = Bopp_Prata :
                                (radio === '8') ? MateriaPrima = Vinil :
                                    <></>

    useEffect(() => {
        setRetornoTotal(total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))
    }, [total])

    useEffect(() => {
        (focused === false) ?
            calcular()
            : <></>
    }, [focused])


    const calcular = () => {

        const etiqQuantNumber = Number(etqquantidade)
        const etiqAlturaNumber = Number(etqaltura)
        const etiqLarguraNumber = Number(etqlargura)
        const radioNumber = Number(radio)

        let tamanhoetiq = (etiqAlturaNumber * etiqLarguraNumber) / 1000

        let qtdCarreirasRolo = Math.trunc(300 / (etiqLarguraNumber + 6)) // calculo de qtas carreiras cabem no papel
        let qtdLinearMP = ((etiqAlturaNumber + 5) * etiqQuantNumber / 1000) / qtdCarreirasRolo // linear p/ calculo click
        const Custo_Click = qtdLinearMP * 2.30 // Calculo Click

        let LarguraEtiq = 330 / Math.trunc(qtdCarreirasRolo); // qtas carreiras cabem na largura do material
        const MetroQ = ((LarguraEtiq * (etiqAlturaNumber + 5)) / 1000000) * etiqQuantNumber;
        const calcMP = Number(MetroQ * MateriaPrima);

        var ValorCorte = '';
        tamanhoetiq < 2.50 ? ValorCorte = Number(0.08 * etiqQuantNumber) :
            tamanhoetiq < 2.25 ? ValorCorte = Number(0.10 * etiqQuantNumber) :
                tamanhoetiq < 2.00 ? ValorCorte = Number(0.12 * etiqQuantNumber) :
                    tamanhoetiq < 1.50 ? ValorCorte = Number(0.14 * etiqQuantNumber) :
                        tamanhoetiq < 1.00 ? ValorCorte = Number(0.18 * etiqQuantNumber) :
                            tamanhoetiq < 0.625 ? ValorCorte = Number(0.20 * etiqQuantNumber) : <></>

        ValorCorte = Number(0.025 * etiqQuantNumber);  // cada mil etiq cortada cobra 20.00
        const Ajuste_Máquina = 2.30 * MateriaPrima // Perca de material

        const soma1 = calcMP + Custo_Click

        let Margem0 = soma1 * 1.50 // Margem de Lucro até 1 M²
        let Margem1 = soma1 * 1.25 // Margem de Lucro até 2 M²
        let Margem2 = soma1 * 1.10 // Margem de Lucro até 4 M²
        let Margem3 = soma1 * 1.00 // Margem de Lucro até 7 M²
        let Margem4 = soma1 * 0.80 // Margem de Lucro até 14 M²
        let Margem5 = soma1 * 0.65 // Margem de Lucro acima de 14 M²

        const soma2 = MetroQ <= 2 ? Margem0 : MetroQ <= 2 ? Margem1 : MetroQ <= 4 ? Margem2 : MetroQ <= 7 ? Margem3 : MetroQ <= 14 ? Margem4 : MetroQ > 14 ? Margem5 : <></>

        var soma = ''

        const soma3 = ValorCorte + Ajuste_Máquina

        const presoma = soma1 + soma2 + soma3

        let adicionalMinimo = (100 - presoma) + ValorCorte // Adicional para dar um valor minimo de 100.00

        presoma > 100 ? soma = presoma : soma = presoma + adicionalMinimo

        radioNumber ? setTotal(soma) : <></>
    };

    return (
        <>

            <Body>

                <TopoSeta>
                    <BotaoLeft>
                        <Link to='/'>
                            <img className="left" src={SetaEsquerda} alt="seta voltar pagina inicial" />
                        </Link>
                    </BotaoLeft>
                    <SiteTopo />
                </TopoSeta>

                <DivDigital>
                    <div className="CalcDigital">

                        <div className="topo">
                            <div>Impressão Digital<br />
                                Orçamento de Etiquetas</div>
                        </div>

                        <hr />

                            <div className="titulo">
                                <div className="subtitulo">Selecione o Material</div>
                                <select
                                    name='radio' value={radio}
                                    onFocus={() => setFocused(true)}
                                    onBlur={() => setFocused(false)}
                                    onChange={e => setRadio(e.target.value)}>
                                    <option value="1" >COUCHE</option>
                                    <option value="2">BOPP FOSCO/BRILHO (Cola Acilica 20gr)</option>
                                    <option value="3">BOPP FOSCO (Cola Borracha 30gr)</option>
                                    <option value="4">BOPP BRILHO (Cola Borracha 30gr)</option>
                                    <option value="6">BOPP TRANSPARENTE</option>
                                    <option value="7">BOPP PRATA</option>
                                    <option value="8">VINIL BRANCO</option>
                                    <option value="5">COUCHE VERGARA (Especial P/ Vinho e Chocolate)</option>
                                </select>
                            </div>

                        <div className="titulo">
                            <div className="subtitulo">Quantidade de Etiquetas</div>
                            <div className="alerta">Preencha a quantidade de etiquetas com um minimo de 100</div>
                            <input
                                type="number" name='etqquantidade' value={etqquantidade}
                                onChange={(e) => setEtqquantidade(e.target.value)}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                            />
                        </div>

                        <div className="titulo">
                            <div className="subtitulo">Largura da Etiqueta (mm)</div>
                            <div className="alerta">Preencha a largura da etiqueta com o minimo de 25 e maximo de 295</div>
                            <input
                                type="number" name='etqlargura' value={etqlargura}
                                onChange={(e) => setEtqlargura(e.target.value)}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                            />
                        </div>

                        <div className="titulo">
                            <div className="subtitulo">Altura da Etiqueta (mm)</div>
                            <div className="alerta">Preencha a altura da etiqueta com o minimo de 25 e maximo de 295</div>
                            <input
                                type="number" name='etqaltura' value={etqaltura}
                                onChange={(e) => setEtqaltura(e.target.value)}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                            />
                        </div>

                        <div>
                            <button onClick={calcular}>Calcular</button>
                        </div>

                        {
                        (etqaltura) <= 295 &  (etqaltura > 24)  & (etqlargura) < 296 &  (etqlargura > 24) & (etqquantidade > 99)
                            ?
                            <div className="resultado">
                                O total de {etqquantidade} etiquetas é {retornoTotal} </div>
                            : <p className="resultado">Preencha todos os campos !!!</p>
                        }
                    </div>
                </ DivDigital>
            </ Body>
        </>
    )
}
export default CalcDigital;
